// extracted by mini-css-extract-plugin
export default {"info-cards":"InfoCards_info-cards__2j6fT"};